import { service } from '@ember/service';
import StrategyCalculation from '../StrategyCalculation';
import { action } from '@ember/object';

export default class StrategyStrategySheetIndexComponent extends StrategyCalculation {
  @service betaToggle;

  get scenario() {
    return this.args.scenario ?? {};
  }

  @action
  to_euro(person_weeks) {
    return person_weeks * this.organisation.ppw;
  }
}
